(() => {
  if (window.tp1022FeedbackReady) return;
  window.tp1022FeedbackReady = true;
  const init = (root) => {
    root.querySelectorAll('[data-tp1022-feedback]').forEach((carousel) => {
      if (carousel.dataset.tp1022FeedbackBound) return;
      const slides = [...carousel.querySelectorAll('[data-tp1022-feedback-slide]')];
      const prev = carousel.querySelector('[data-tp1022-feedback-prev]');
      const next = carousel.querySelector('[data-tp1022-feedback-next]');
      const counter = carousel.querySelector('[data-tp1022-feedback-counter]');
      if (!slides.length || !prev || !next || !counter) return;
      carousel.dataset.tp1022FeedbackBound = 'true';
      let active = 0;
      const show = (index) => {
        active = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== active; });
        counter.textContent = `${active + 1} / ${slides.length}`;
      };
      prev.addEventListener('click', () => show(active - 1));
      next.addEventListener('click', () => show(active + 1));
      show(0);
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
